var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { attrs: { cols: "12", sm: "10", md: "8", lg: "6", xl: "6" } },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-title",
            [
              _c("v-row", { attrs: { align: "center", justify: "center" } }, [
                _c("h3", [_vm._v(_vm._s(_vm.$t("views.constants.register")))])
              ])
            ],
            1
          ),
          _c("company-form", { attrs: { isEditMode: false } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }